import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'search-drop-down',
  templateUrl: './search-drop-down.component.html',
  styleUrls: ['./search-drop-down.component.css']
})
export class SearchDropDownComponent implements OnInit {
  inputFocused: boolean;
  callCount: number;
  ignoreUpdate: boolean;
  stdplaceholder: string = "Type to search...";
  suggestions: any[];
  selectedIndex: any;
  @Input("model") selectedTags: string;
  @Input() dropDownList: any[];
  @Input("disable") disabled: any;
  @Input("search-required") required: any;
  @Input() searchText: string;
  @Input() where: string;
  @Input() selected: boolean;
  @Input() focused: any;
  @Input("display-key") displayKey: any;
  @Input() modelKey: any;
  @Input() placeholder: string;
  @Input() warningMsg: string;
  @Output() searchTextChanged: EventEmitter<any> = new EventEmitter();
  @Output("value-change") vchange: EventEmitter<any> = new EventEmitter();
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() modelChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
    this.inputFocused = false;
    this.callCount = 0;
    this.ignoreUpdate = false;
    if (this.selectedTags == "" || this.selectedTags == null)
      this.selected = false;
    else
      this.selected = true;
    this.suggestions = [];
    this.selectedIndex = -1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dropDownList != null && (this.where == "super" || this.where == "freeTextBlurSave")) {
      this.callCount++;
      if (this.inputFocused) {
        this.searchValues();
      }
    }
  }

  search() {
    this.searchTextChange.emit(this.searchText);
    if (!this.ignoreUpdate) {
      if (this.selected == true && this.searchText != undefined && this.dropDownList != null) {
        this.dropDownList.forEach((key: any, val: any) => {
          if (this.where == "super" || this.where == "freeTextBlurSave") {
            //do nothing (:
          }
          else if (this.where == "simple") {
            if (val != null) {
              if (val.toLowerCase() == this.searchText.toLowerCase()) {
                return false;
              } else if (key == this.dropDownList.length - 1) {
                this.selectedTags = null;
                this.modelChange.emit(this.selectedTags);
                this.searchText = null;
                this.searchTextChange.emit(this.searchText);
                this.suggestions = [];
                this.selected = false;
                setTimeout(() => {
                  if (this.vchange != null)
                    this.vchange.emit();
                });
              }
            }
          } else {
            if (val.DisplayValue != null) {
              if (val.DisplayValue.toLowerCase() == this.searchText.toLowerCase()) {
                return false;
              } else if (key == this.dropDownList.length - 1) {
                this.selectedTags = "";
                this.modelChange.emit(this.selectedTags);
                this.searchText = "";
                this.searchTextChange.emit(this.searchText);
                this.suggestions = [];
                this.selected = false;
                setTimeout(() => {
                  if (this.vchange != null)
                    this.vchange.emit();
                });
              }
            }
          }
        });
      }
      if (this.inputFocused) {
        setTimeout(() => {
          this.searchTextChanged.emit(this.searchText);
        });
      }
    }
    else {
      this.ignoreUpdate = false;
    }
    setTimeout(() => {
      if (this.inputFocused) {
        this.searchValues();
      }
    });
  }
  searchValues() {
    //Put search logic here
    if (this.searchText !== null && this.searchText !== undefined && this.searchText.length > 1 && this.inputFocused) {
      var suggestions = [];
      if (this.dropDownList && this.dropDownList !== undefined) {
        if (this.dropDownList.length >= 20 && (this.where == "super" || this.where == "freeTextBlurSave")) {
          //add first 20 items
          for (var i = 0; i < 20; i++) {
            if (this.displayKey != null) {
              //just push everything b/c it should be a smarter lookup, right?
              if (this.modelKey != null)
                suggestions.push({ DatabaseValue: this.dropDownList[i][this.modelKey], DisplayValue: this.dropDownList[i][this.displayKey] });
              else {
                suggestions.push({ DatabaseValue: this.dropDownList[i], DisplayValue: this.dropDownList[i][this.displayKey] });
              }
            }
            else {
              suggestions.push(this.dropDownList[i]);
            }
          }
          suggestions.push({ DatabaseValue: -1, DisplayValue: "More results found... continue typing to search." });
        }
        else {
          this.dropDownList.forEach((val: any) => {
            if (this.where == "simple") {
              if (val != null) {
                if (val.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 && suggestions.length < 20) {
                  suggestions.push({ DisplayValue: val, DatabaseValue: val });
                }

                if (suggestions.length == 20) {
                  suggestions.push({ DatabaseValue: -1, DisplayValue: "More results found... continue typing to search." });
                }
              }
            } else if (this.where == "progress") {
              if (val.JobDisplayName != null) {
                if (val.JobDisplayName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 && suggestions.length < 20) {
                  suggestions.push({ DisplayValue: val.JobDisplayName, DatabaseValue: val.JCJMKeyID });
                }

                if (suggestions.length == 20) {
                  suggestions.push({ DatabaseValue: -1, DisplayValue: "More results found... continue typing to search." });
                }
              }
            }
            else if (this.where == "super" || this.where == "freeTextBlurSave") {
              if (this.displayKey != null) {
                //just push everything b/c it should be a smarter lookup, right?
                if (this.modelKey != null)
                  suggestions.push({ DatabaseValue: val[this.modelKey], DisplayValue: val[this.displayKey] });
                else {
                  suggestions.push({ DatabaseValue: val, DisplayValue: val[this.displayKey] });
                }
              }
              else {
                suggestions.push(val);
              }
            }
            else {
              if (val.DisplayName != null) {
                if (val.DisplayValue.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 && suggestions.length < 20) {
                  suggestions.push(val);
                }

                if (suggestions.length == 20) {
                  suggestions.push({ DatabaseValue: -1, DisplayValue: "More results found... continue typing to search." });
                }
              }
            }
          });
        }
      }
      this.suggestions = suggestions;
      if (this.suggestions.length == 0)
        this.selectedIndex = -1;
      else {
        if (this.selectedIndex == -1 || this.selectedIndex > this.suggestions.length) {
          this.selectedIndex = 0;
        }
      }
    } else
      this.suggestions = [];
  }

  checkKeyDown(event) {
    if (event.keyCode === 40) {//down key, increment selectedIndex
      event.preventDefault();
      if (this.selectedIndex + 1 !== this.suggestions.length) {
        this.selectedIndex++;
      }
    }
    else if (event.keyCode === 38) { //up key, decrement selectedIndex
      event.preventDefault();
      if (this.selectedIndex - 1 !== -1) {
        this.selectedIndex--;
      }
    }
    else if (event.keyCode === 13) { //enter pressed
      event.preventDefault();
      this.addToSelectedTags(this.selectedIndex, true);
    }
    else if (event.keyCode === 9 && this.suggestions.length > 0) { //tab pressed
      this.addToSelectedTags(this.selectedIndex, false);
    }
    else if (this.selectedTags != null && this.searchText != null && this.selectedTags != "" && this.searchText != "" && (event.keyCode == 8)) {
      this.searchText = "";
      this.searchTextChange.emit(this.searchText);
      this.selectedTags = null;
      this.modelChange.emit(this.selectedTags);
    }
  }

  addToSelectedTags(index, inputStillFocused: boolean) {
    if (index != -1 && index != 20) {
      if (this.suggestions[index] != null) {
        this.selectedTags = (this.suggestions[index].DatabaseValue);
        this.modelChange.emit(this.selectedTags);
      }
      this.ignoreUpdate = true;
      if (this.suggestions[index] != null) {
        this.searchText = this.suggestions[index].DisplayValue;
        this.searchTextChange.emit(this.searchText);
      }
      this.suggestions = [];
      this.inputFocused = inputStillFocused == true;
      index = -1;
      setTimeout(() => {
        if (this.vchange != null)
          this.vchange.emit();;
      });
      this.selected = true;
    } else if (index != 20) {
      this.searchText = "";
      this.searchTextChange.emit(this.searchText);
      this.selectedTags = "";
      this.modelChange.emit(this.selectedTags);
    }
  }

  check() {
    //off focus and set condition for free text blur trigger
    this.inputFocused = false;
    if (this.where == "freeTextBlurSave") {
      setTimeout(() => {
        if (this.vchange != null)
          this.vchange.emit();;
      });
    }
  }

  clearValues() {
    this.searchText = "";
    this.searchTextChange.emit(this.searchText);
    this.selectedTags = "";
    this.modelChange.emit(this.selectedTags);
  }

  fieldFocused() {
    this.inputFocused = true;
    if (this.focused != null)
      this.focused();
  }

}
